import { render, staticRenderFns } from "./ListaProduto.vue?vue&type=template&id=b375980e&scoped=true"
import script from "./ListaProduto.vue?vue&type=script&lang=js"
export * from "./ListaProduto.vue?vue&type=script&lang=js"
import style0 from "./ListaProduto.vue?vue&type=style&index=0&id=b375980e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b375980e",
  null
  
)

export default component.exports